import React from 'react';
import { AstralInfo } from '../../hooks/useAstralInfo';

interface Props {
  astralInfo: AstralInfo | null;
}

const NumerologiaPessoal: React.FC<Props> = ({ astralInfo }) => {
  if (!astralInfo) return null;

  return (
    <div className="backdrop-blur-sm rounded-xl p-6 border border-white/20" style={{ background: 'rgba(255,255,255,0.05)' }}>
      <h3 className="text-sm font-semibold text-gray-300 mb-3 flex items-center gap-2">
        <span className="text-base">🔢</span>
        {astralInfo.numerologyLabels ? 'Numerologia Pessoal' : 'Números da Sorte'}
      </h3>

      {astralInfo.numerologyLabels ? (
        <>
          <div className="grid grid-cols-2 gap-2">
            {astralInfo.luckyNumbers.map((number, index) => {
              const isPermanent = index < 4;
              return (
                <div
                  key={index}
                  className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 p-3 rounded-xl"
                  style={{
                    background: isPermanent
                      ? 'linear-gradient(135deg, rgba(251,191,36,0.08) 0%, rgba(251,191,36,0.03) 100%)'
                      : 'linear-gradient(135deg, rgba(139,92,246,0.10) 0%, rgba(139,92,246,0.03) 100%)',
                    border: isPermanent
                      ? '1px solid rgba(251,191,36,0.2)'
                      : '1px solid rgba(139,92,246,0.25)',
                  }}
                >
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg flex-shrink-0 mx-auto sm:mx-0"
                    style={{
                      background: isPermanent
                        ? 'rgba(251,191,36,0.15)'
                        : 'rgba(139,92,246,0.18)',
                      color: isPermanent ? '#fbbf24' : '#a78bfa',
                    }}
                  >
                    {number}
                  </div>
                  <div className="min-w-0 text-center sm:text-left">
                    <div className="text-sm font-semibold text-white leading-tight">
                      {astralInfo.numerologyLabels![index]}
                    </div>
                    {astralInfo.numerologyDescriptions?.[index] && (
                      <div className="text-xs text-gray-400 mt-0.5 leading-snug italic">
                        {astralInfo.numerologyDescriptions[index]}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mt-3 flex gap-3 text-xs text-gray-500">
            <span className="flex items-center gap-1">
              <span className="w-2 h-2 rounded-full bg-yellow-400/60 flex-shrink-0"></span>
              Permanentes
            </span>
            <span className="flex items-center gap-1">
              <span className="w-2 h-2 rounded-full bg-purple-400/60 flex-shrink-0"></span>
              Temporais
            </span>
          </div>
        </>
      ) : (
        <div className="flex flex-wrap gap-2">
          {astralInfo.luckyNumbers.map((number, index) => (
            <span key={index} className="w-9 h-9 bg-gold-400/20 text-gold-400 rounded-full flex items-center justify-center text-sm font-bold">
              {number}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default NumerologiaPessoal;
